import { forwardRef } from "react";

import { UseLogoProps, useLogo } from "./use-logo";
import { LogoFull, LogoFavicon, LogoMini } from "./components";

export interface LogoProps extends UseLogoProps {}

const Logo = forwardRef<HTMLElement, LogoProps>((props, ref) => {
  const { getLogoProps, domRef, variant } = useLogo({ ...props, ref });

  switch (variant) {
    case "full":
      return <LogoFull ref={domRef} {...getLogoProps()} />;
    case "mini":
      return <LogoMini ref={domRef} {...getLogoProps()} />;
    case "favicon":
      return <LogoFavicon ref={domRef} {...getLogoProps()} />;
    default:
      return <LogoFull ref={domRef} {...getLogoProps()} />;
  }
});

Logo.displayName = "UI.Logo";

export default Logo;
